import { makeStyles } from '@mui/styles'

const backgroundStyle = makeStyles(() => ({
  video1: {
    width: '60vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    right: 0,
    backgroundColor: 'black',
  },
  video: {
    height: '80vh',
    position: 'absolute',
    top: '30px',
    left: '70px',
  },

  video2: {
    zIndex: 0,
    width: '60vw',
    height: '85vh',
    position: 'fixed',
    top: '100vh',
    backgroundColor: 'black',
    left: 0,
  },
  noise: {
    position: 'absolute',
    top: '-500px',
    right: '-500px',
    bottom: '-500vh',
    left: '-500px',
    overflow: 'hidden',
    background:
      'transparent url(https://www.dropbox.com/s/h7ab1c82ctzy83n/noise.png?raw=1) 0 0',
    backgroundSize: '320px 320px',
    opacity: '0.15',
    animation: '$noises 1s steps(8, end) infinite both',
  },

  '@keyframes noises': {
    '0%': {
      transform: 'translateX(0px, 0px)',
    },
    '10%': {
      transform: 'translate(-100px, 100px)',
    },
    '20%': {
      transform: 'translate(150px, -100px)',
    },
    '30%': {
      transform: 'translate(-100px, 100px)',
    },
    '40%': {
      transform: 'translate(100px, -150px)',
    },
    '50%': {
      transform: 'translate(-100px, 200px)',
    },
    '60%': {
      transform: 'translate(-200px, -100px)',
    },
    '70%': {
      transform: 'translateY(50px, 100px)',
    },
    '80%': {
      transform: 'translate(100px, -150px)',
    },
    '90%': {
      transform: 'translate(0px, 200px)',
    },
    '100%': {
      transform: 'translate(-100px, 100px)',
    },
  },
}))
export default backgroundStyle
